// ai预览
const getAiList='getAiList'
export const getAiData = () => sessionStorage.getItem(getAiList);
export const setAiData = (AiList) => sessionStorage.setItem(getAiList, AiList);
export const removeAiData = () => sessionStorage.removeItem(getAiList);